import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild, ElementRef, TemplateRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map} from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { MysqlService } from './../../../services/mysql.service';
import { BsModalService } from 'ngx-bootstrap';

// sycfusion dialog 
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { JobSubject } from './../../../shared/models/jobSubject.model';
import { NgForm } from '@angular/forms';
// import { ToolbarService } from '@syncfusion/ej2-angular-grids';
import { ToolbarService, HtmlEditorService, CountService, ImageService, LinkService, PasteCleanupService } from '@syncfusion/ej2-angular-richtexteditor';
import { DocumentEditorComponent } from '@syncfusion/ej2-angular-documenteditor';
import { JobCreateFormSubjectAdditionsComponent } from '../job-create-form-subject-additions/job-create-form-subject-additions.component';
import { LegalDateTimeService } from '../../../services/legal-datetime.service';


@Component({
  selector: 'app-job-details-edit-widget-client',
  templateUrl: './job-details-edit-widget-client.component.html',
  styleUrls: ['./job-details-edit-widget-client.component.scss'],
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, CountService, PasteCleanupService ]
})
export class JobDetailsEditWidgetClientComponent implements OnInit {

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full

   @Input() redirect_subject_id?; // added so that when a client subits I can redirect to subject card.


// new dynaci for to save data below to fields if pressed early
@ViewChild(JobCreateFormSubjectAdditionsComponent)
dynamicFormComponent: JobCreateFormSubjectAdditionsComponent;




//// SyncFusion Dialog
@ViewChild('ejDialog') ejDialog: DialogComponent;
// Create element reference for dialog target element.
@ViewChild('container', { read: ElementRef }) container: ElementRef;
// The Dialog shows within the target element.

@ViewChild('defaultRTE')
public defaultRTE: DocumentEditorComponent;

     // access the template form
     @ViewChild('jobForm') jobForm: NgForm;

  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: any;
  JobStep2ID: any;
  model: any;
  job_types: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: any;
  job_type_document_types: any;
  sent_job_type_court_id: any;
  job_type_affidavit_types: any;
  sent_job_type_document_type_id: any;
  clients: any;
  client_contacts: any;
  sent_client_id: any;
  positionsMysql: any;
  get_subjects: any;
  job_subject_types: any;
  job_plaintiff_types: any;
  sessionUsername: any;
  brands: any;
  brand_users: any;
  sent_brand_id: any;
  brand_report_selected: any;
  selected_brand_data: any;
  new_special_instuctions: any;
  special_instructions: any;
  job_id: any;
  DialogObj: any;
  client_job_submission: any;
  job_type: any;
  job_service_rules: any;
  job_service_timeframes: any;
  sent_job_service_rule_id: any;
  job_type_document_type: any;
  selected_job_service_rule_description: any;
  selected_job_service_timeframe_description: any;
  job_service_rule: any;
  job_service_timeframe: any;
  modalRef: any;
  job_plaintiffs: any;
  all_router_details: string;
  job_status: any;
  hide_content_from_client: number;

  changes_made: any = 1;
  jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};
  private readonly legalJobDateFields = ['judgement_date', 'filing_date', 'hearing_date', 'instructions_date'];


  // Text editor Settings
  public simpleToolBar: object = {
    type: 'Expand',
    enableFloating: false,
    items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
    'FontSize', 'FontColor', 'BackgroundColor',
    'LowerCase', 'UpperCase', '|',
    'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
    'Outdent', 'Indent', '|',
    'CreateLink', '|', 'ClearFormat', 'Print',
    'SourceCode', '|', 'Undo', 'Redo',
    // {
    //   tooltipText: 'Insert Promotion',
    //   undo: true,
    //   click: this.onClickPromotionButton.bind(this),
    //   template: '<button type="button" class="btn btn-default"><i class="fa fa-qrcode"></i></button>'
    // }
  ],
  table: ['TableHeader', 'TableRows', 'TableColumns', 'TableCell', '-', 'BackgroundColor', 'TableRemove', 'TableCellVerticalAlign', 'Styles']
    };
    public pasteCleanupSettings: object = {
      prompt: true,
      plainText: false,
      keepFormat: false,
      deniedTags: ['a'],
      deniedAttrs: ['class', 'title', 'id'],
      allowedStyleProps: ['color', 'margin', 'font-size']
  }; 


  constructor(   private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public datepipe: DatePipe,
     public gfunc: GlobalFunctionsService,
     public legalDate: LegalDateTimeService) {

      this.nav = document.querySelector('nav.navbar');
    //  this.toastr.setRootViewContainerRef(vcr);

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


  // Set the client uses to select for reporut user
  this.sendBrandID(this.sessionBrandId);


      }

      ngOnInit(): void {
        this.hide_content_from_client = 0;
        if (this.router.url.includes('/client/jobs/create-job-wizard-step-')) {
          this.hide_content_from_client = 1;
          console.log('We are on client page  - create job')
        } else {
          //  return '';
        }
      }
      
      

         // check for changes. to load data.
   ngOnChanges(changes) {
    this.hide_content_from_client = 0;

  if (this.router.url.includes('/client/jobs/create-job-wizard-step-')) {
          this.hide_content_from_client = 1;
          console.log('We are on client page  - create job')
        } else {
          //  return '';
        }


    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.job_id = changes.item_id.currentValue;
      this.getJob(this.job_id);
      this.getJobServiceRules();
      this.getJobServiceTimeframes();
     this.getJobStatusNames();
      // have to reset the route as it was not hiding the fields I required.
      this.gfunc.current_base_route = this.router.url.substr(0, this.router.url.lastIndexOf('/'));
    }




  }


  onChangePromtSave(any) {
    //  alert('you have made changes, please remember to save!');
    //  console.log('form changed');
     this.changes_made = null;
    }


  getJob(job_id) {


    this.getJobTypes();
    this.getPositions();
    this.getClients();
    this.getJobSubjectTypes();
    this.getJobPlaintiffTypes();
    this.getBrands();
    this.getJobPlaintiffs(job_id);

    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        let res = data[0];
      this.initializeJobDatePickerValues(this.job);
      // Need to load the drop downs (only if a process is selected.)
      this.getJobTypeLocations(res.job_type_id);
      this.getJobTypeCourts(res.job_type_location_id);
      this.getJobTypeDocumentTypes(res.job_type_court_id);
      this.getJobTypeAffidavitTypes(res.job_type_document_type_id);
      // need to load client contact
      this.getClientContactsSharmans(res.client_id);

      // Auto load into HTML
      // NOW adds correctly at step one for a cleiint.
      // if(res.special_instructions_HTML == undefined){
      //   this.toastr.error('Special HTML not defined');
      //   // this.jobForm.controls['special_instructions'].patchValue(res.special_instructions); // patch the form
    
      // }
      
      this.getBrandUsers(res.brand_report_id);
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  



// syncfusion dialog simple sample
public onOpenDialog = function(event: any, model): void {

  // save the updated detauls before submissiion fix may 2025
  this.updateJobStep3(model);

  this.DialogObj = DialogUtility.confirm({
    title: 'Save + Send Job ',
    // tslint:disable-next-line:max-line-length
    content: '<b> <i class="fa fa-check-circle fa-2x pull-left text-success"></i> By pressing Submit below the details of the job will be activated in the system, ready for Sharmans approval and service.</b> <br><br> <p class="text-muted font-bold">Sharmans will notify you when this job approved ready for service. Once Submitted you will no longer be able to edit the job details directly, but can upload files or notes at any time.</p> ',
    okButton: {  text: '<i class="fa fa-check-circle text-success"></i> Submit Job',  click: this.okClick.bind(this, model) },
    cancelButton: {  text: 'Not just Yet.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}


public onOpenDialogAdmin = function(event: any, model): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Job Submissions <span class="text-danger font-bold"> ::[ OPEN JOB & SUBJECTS ]:: ',
    // tslint:disable-next-line:max-line-length
    content: '<b>OPEN job ready for processing in the portal!</b> <br><br> <p class="text-success font-bold">We will notify the Report Client its ready and in service.</p> ',
    okButton: {  text: 'OK', click: this.okClickAdmin.bind(this) },
    cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}

public okClick(model): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 // this.createJobSubjectsMultiple(this.newSubject);
      /// this.updateJobAll(model); // Added to make sure step three saves first before submitting the details. move this to an on blur event....
 this.clientJobSubmission(this.job_id, model);
 this.DialogObj.hide();
}

private okClickAdmin(model): void {
  //  alert('you clicked Yes, Please! are you really really sure??? Really');
  // this.createJobSubjectsMultiple(this.newSubject);
  if( model.special_instructions_HTML == ''){
  model.special_instructions_HTML = model.special_instructions_HTML;
  }

  this.adminJobSubmission(this.job_id, model);
  this.DialogObj.hide();
  

 }

  getJobDateKey(model: any): string {
    return String(model?.job_id ?? '');
  }

  getJobDatePickerValue(model: any, field: string): Date | null {
    const key = this.getJobDateKey(model);
    return this.jobDatePickerValues[key]?.[field] ?? null;
  }

  onJobDateChange(field: string, value: unknown, model: any): void {
    const key = this.getJobDateKey(model);
    const pickerDate = this.legalDate.coercePickerDate(value);

    if (!this.jobDatePickerValues[key]) {
      this.jobDatePickerValues[key] = {};
    }

    this.jobDatePickerValues[key][field] = pickerDate;
    model[field] = this.legalDate.fromPickerDate(pickerDate);
  }

  private initializeJobDatePickerValues(jobs: any[]): void {
    if (!Array.isArray(jobs)) {
      this.jobDatePickerValues = {};
      return;
    }

    const jobDatePickerValues: { [key: string]: { [field: string]: Date | null } } = {};

    jobs.forEach((jobModel) => {
      const key = this.getJobDateKey(jobModel);
      jobDatePickerValues[key] = {};

      this.legalJobDateFields.forEach((field) => {
        jobDatePickerValues[key][field] = this.legalDate.toPickerDate(jobModel?.[field]);
      });
    });

    this.jobDatePickerValues = jobDatePickerValues;
  }

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}



// :: Send Job: Client Submission update all subjects and job to pending
clientJobSubmission(job_id, model){

  // New Special Instructions formatting (Save Old into New Ready to Go Live.)
// remove this as a bug not saving special instuctions.
// if(model.special_instructions_HTML == null){model.special_instructions_HTML = model.special_instructions}

model.updated_date = this.gfunc.todayDate
model.updated_by = this.gfunc.sessionUserId

  this._demoService.clientJobSubmission(job_id)
  .subscribe(
    res => {
      this.client_job_submission = res;
     // let data = res[0];


// console.log('Submission Model: ' + JSON.stringify(model));

     this.gfunc.insertLog_UpdateJobSubmission(model);


     this.toastr.success('Job Submitted, thank you!.');

    //  this.gfunc.globalJobView(job_id);


    },
    err => console.error(err.status),
    () => {
      
      // this.gfunc.globalJobView(job_id);
      // redirect to subject instead... 
      this.gfunc.globalJobSubjectCardSkipRoute(this.redirect_subject_id);
     }
  );
}


// Need this to be upgraded to include the model for the log action trigger event.
adminJobSubmission(job_id, model){

  // New Special Instructions formatting (Save Old into New Ready to Go Live.)
  if(model.special_instructions_HTML == null){model.special_instructions_HTML = model.special_instructions}

  model.updated_date = this.gfunc.todayDate
  model.updated_by = this.gfunc.sessionUserId


  /// Add new dynaic form logic here and append the HTML to special instructions here..... for the job special intrucitons only.
  
          // if(this.gfunc.sessionBrandUserUILayoutID == 2){
          //   // get the child form data
          //   const dynamicData = this.dynamicFormComponent?.getDynamicFormOutput();

          // model = {
          //     ...model,
          //     client_additional_create_data: JSON.stringify(dynamicData.data),
          //     client_additional_create_data_HTML: dynamicData.html,
          //     updated_date: this.gfunc.todayDate,
          //     updated_by: this.gfunc.sessionUserId,
          //   special_instructions_HTML: (model?.special_instructions_HTML || '') + dynamicData.html // Only do this when submitting the job....

          //   };
          // }


  this._demoService.adminJobSubmission(job_id)
  .subscribe(
    res => {
      this.client_job_submission = res;
     // let data = res[0];
     this.toastr.success('Job Submitted.');
      // Now log and log trigger event.
      this.gfunc.insertLog_OpenJobReadyForAction(model);


     this.gfunc.globalJobView(job_id);
    },
    err => {console.error(err.status)},

     () => {
      this.gfunc.globalJobView(job_id);
     }
  );
}


// get job type details.
getJobType(job_type_id) {
  this._demoService.getJobType(job_type_id).subscribe(
     data => { 
      this.job_type = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

  
  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobSubjectTypes() {
    this._demoService.getJobSubjectTypes().subscribe(
       data => { this.job_subject_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getJobPlaintiffTypes() {
    this._demoService.getJobPlaintiffTypes().subscribe(
       data => { this.job_plaintiff_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
  
  
  
   console.log('sending Count:' + this.count2);
  }
  
  
  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  
  
  
   console.log('sending Location:' + this.sent_job_type_location_id);
  }
  
  
  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; 

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }
  


  sendJobServiceRuleID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    // this.sent_job_service_rule_id = job_service_rule_id;

    this.sent_job_type_document_type_id = job_type_document_type_id;
  //  this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  


          //   IMPLIMENTATION of Service Timeframes & Service Rules associated with document selection
          // ::@ Try to set the service rule and service timeframes from document here.
          //    What is the current selected DocumentID - lookup the  timeframes, and service rule IDS
          //    Then set them into the model and save as new variables as part of the job.
          //     TODO:: need to impliment this on create a job and set for all subjects on a subject level with defaults.
          //  this.model.job_service_rule_id = 
  



// Now lookup the Serice rule and set the selection with the ids.
    this.getJobTypeDocumentType(this.sent_job_type_document_type_id);
// NOW need to repeat this action for the service timeframes.


   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }



  getJobTypeDocumentType(job_type_document_type_id) {
    this._demoService.getJobTypeDocumentType(job_type_document_type_id).subscribe(
       data => { this.job_type_document_type = data;
      let res = data[0];
      // Set the new form variables After the selected drop down of documents activated this function;
      // note :: SUCCESS (This also updates the model object variables in the form)
      this.jobForm.controls['job_service_rule_id'].setValue( res.job_service_rule_id);
      this.jobForm.controls['job_service_timeframe_id'].setValue( res.job_service_timeframe_id);
   
// Display the Rule Definition in UI/Template
// Need to do a quick lookup to get the values to set below both Timeframes and Rule Definitions on the page

this.getJobServiceRule(res.job_service_rule_id);
this.getJobServiceTimeframe(res.job_service_timeframe_id);





      // this.model.job_service_rule_id = res.job_service_rule_id;
      //   console.log('New job_service_rule_id ' + this.model.job_service_rule_id);
    },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

  
  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  
   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }
  
  
  


  getJobServiceRule(job_service_rule_id) {
    this._demoService.getJobServiceRule(job_service_rule_id).subscribe(
       data => { this.job_service_rule = data; 
        let res = data[0];
        this.selected_job_service_rule_description = res.job_service_rule_description;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframe(job_service_timeframe_id) {
    this._demoService.getJobServiceTimeframe(job_service_timeframe_id).subscribe(
       data => { this.job_service_timeframe = data; 
        let res = data[0];
        this.selected_job_service_timeframe_description = res.job_service_rule_time_frame_text;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }






  getClients() {
    this._demoService.getClients().subscribe(
       data => { this.clients = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getClientContactsSharmans(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
       data => { this.client_contacts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   sendClientID(client_id) {
   this.sent_client_id = client_id;
   this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....
  
   console.log('sending Client ID:' + this.sent_client_id);
  }
  
  private getPositions() {
    this._demoService.getPositions()
      .subscribe(
        res => this.positionsMysql = res,
        err => console.error(err.status)
      );
  }
  
  
  
  // update was here for onit but moved for onchange
  updateJobAll(model) {
  
model.updated_date = this.gfunc.todayDate
model.updated_by = this.gfunc.sessionUserId

    // New Special Instructions formatting (Save Old into New Ready to Go Live.)
if(model.special_instructions_HTML == null){model.special_instructions_HTML = model.special_instructions}

    this._demoService.updateJobAll(model).subscribe(
       data => { 
       this.toastr.success('Job Updated');
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false); // refreshed below component?
      this.gfunc.insertLog_UpdateJob(model);
      this.gfunc.globalJobView(model.job_id);
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error updating your Job!');
        return console.log(error);
       }
  );
  }

  /// Stay amd refresj the page data.
  updateJobStep3(model) {
    // model.updated_by = this.sessionUserId;
    
model.updated_date = this.gfunc.todayDate
model.updated_by = this.gfunc.sessionUserId

// New Special Instructions formatting (Save Old into New Ready to Go Live.)
if(model.special_instructions_HTML == null){model.special_instructions_HTML = model.special_instructions}

if(this.gfunc.sessionBrandUserUILayoutID == 2){
  // get the child form data
  const dynamicData = this.dynamicFormComponent?.getDynamicFormOutput();

 model = {
    ...model,
    client_additional_create_data: JSON.stringify(dynamicData.data),
    client_additional_create_data_HTML: dynamicData.html,
    updated_date: this.gfunc.todayDate,
    updated_by: this.gfunc.sessionUserId,
  };
}


    this._demoService.updateJobAll(model).subscribe(
       data => { 
       this.toastr.success('Job Updated');
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false); // refreshed below component?
      this.gfunc.insertLog_UpdateJob(model);
      this.gfunc.globalJobEditStep3SkipRoute(model.job_id);
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error updating your Job!');
        return console.log(error);
       },
  );
  }
  
  
  
  // create subjects
  createJobSubjectsMultiple(model) {
  
     this._demoService.createJobSubjectsMuliple(model).subscribe(
        data => {  this.get_subjects = data; // this is the retuned json upon creation.
        this.toastr.success('Subjects Saving...');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}
  
         // Setup annd the Currents before we redirec the page
         // Needs to be a Function to update the ObserveOnOperator.
         // this.newCTrace_id(this.latest_trace_id);
         // or this.cdata.changeCTrace_id("999");
   
        // this.router.navigate(['/admin/jobs/create-job-2/' + model.job_id + '']);
   
           return true;
   
   
        },
        error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
         // this.toastr.error('Adding Subjects Failed :: Please try again!');
         // console.log(error(error));
         //return console.log(error);
        }
   );
  }
  
  getBrands() {
    this._demoService.getBrands().subscribe(
       data => { this.brands = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getBrandUsers(brand_report_user_id) {
    this._demoService.getBrandUsers(brand_report_user_id).subscribe(
       data => { this.brand_users = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   sendBrandID(brand_report_user_id) {
   this.sent_brand_id = brand_report_user_id;
   this.getBrandUsers(this.sent_brand_id); // updates the selected job ID....
  // need to look up what brands notes are and send to jon notes.
  // lookup brand
  this.getBrandById_instructions(this.sent_brand_id); // sets the model special instuctions in function
  
   //console.log('sending Brand ID:' + this.sent_brand_id);
  }
  
  getBrandById_instructions(brand_id){
    this._demoService.getBrandById(brand_id)
    .subscribe(
      res => {this.brand_report_selected = res;
        this.selected_brand_data = res[0];
       this.new_special_instuctions = this.selected_brand_data.brand_notes;
       this.special_instructions = this.new_special_instuctions;
       console.log('instructions: ' + this.new_special_instuctions);
     
      },
      err => console.error(err.status)
    );
   }





   getJobServiceRules() {
    this._demoService.getJobServiceRules().subscribe(
       data => { this.job_service_rules = data; },
       err => console.error(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }


   getJobServiceTimeframes() {
    this._demoService.getJobServiceTimeframes().subscribe(
       data => { this.job_service_timeframes = data; },
       err => console.error(err),
        () => {
          console.log('done loading SR');
                      }
          );
   }



 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobViewSkipRoute(this.job_id);
this.getJobPlaintiffs(this.job_id);
};

getJobPlaintiffs(job_id) {
  this._demoService.getJobPlaintiffs(job_id).subscribe(
     data => { this.job_plaintiffs = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }





 deleteJobPlaintiff(job_plaintiff_id) {
  if (confirm('Are you sure you want to delete this Plaintiff? ')) {
    this._demoService.deleteJobPlaintiff(job_plaintiff_id).subscribe(
       data => {
     // reset the plaintiff list.
     this.getJobPlaintiffs(this.job_id);
     this.toastr.warning('Plaintiff removed from job.');
         return true;
       },
       error => {
         console.error('Error deleting !');
        return console.log(error);
       }
    );
}
}

private getJobStatusNames() {
  this._demoService.getJobStatusNames()
    .subscribe(
      res => this.job_status = res,
      err => console.error(err.status)
    );
}





importPrevContentToHTML(id, content_sent, model) {
  if (confirm('Are you sure? Warning: This action will replace any content in the new "Editor" for this specific field.' + id)) {
  // model.id = id+'_HTML'
  // const content = document.getElementById(id).innerText; // copy all formatting.
  // const content = document.getElementById('note_content_' + id).innerText; // wet to copy text and formatting only
  // this.clipboard.copy(this.removeTags(content));
  // this.clipboard.copy(content);

  const content = content_sent; // copy all formatting.
  // this.attemptForm.controls['updated_by'].setValue(id+'_HTML');
  

  // this.attemptForm.controls['general_notes_HTML'].setValue(content);
  this.jobForm.controls[id+'_HTML'].setValue(content);
  model.special_instructions_HTML = content;


  this.toastr.info("Updated Version: " + id+'_HTML')
  // this.LoadSubjectserviceOutcomeTemplateParagraph(model)
  // this.copyInGrid('btnTwo', id);
  }
}






  
  }
  
    // Allows formatting of dates etc...
    export class DatePipeComponent {
      today: number = Date.now();
      fixedTimezone = '2018-04-11T09:03:01+1000'; // Fixed to Brisbane Australia
    // tslint:disable-next-line:eofline
    }
  
